// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__wrapper[data-v-57729c13]{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;margin:0}[data-v-57729c13] .el-dialog{background:#fff!important;height:80%}[data-v-57729c13] .el-dialog .el-dialog__header{height:57px}[data-v-57729c13] .el-dialog .el-dialog__body{height:calc(100% - 57px)}[data-v-57729c13] .el-dialog .el-dialog__body .el-card{border:none!important;box-shadow:none!important;padding-top:50px}", ""]);
// Exports
module.exports = exports;
